export default __webpack_public_path__ + "static/tutorials-watersheddoc-6c2a873a9d917a50410a3d5e85bea9b4.png";